import PageHeader from "@/components/pageHeader";

export const VisionPage = () => {
  const blocks = [
    {
      label: "OUR VISION",
      title: <>Transforming Lives,<br />Leaving a Legacy</>,
      paragraphs: [
        "Our vision is to make a profound impact that will reverberate beyond the boundaries of our tri-city community, transforming lives and leaving a positive legacy that will be remembered for generations to come.",
        "We embrace the future — adapting, innovating, and evolving. Our commitment to trust, credibility, and consistency remains the guiding force behind everything we do.",
      ],
    },
    {
      label: "OUR MISSION",
      title: <>People First,<br />Always</>,
      paragraphs: [
        "Our approach is centered around one fundamental principle: putting people first. We're focused on building relationships, fostering connections, and creating spaces that truly make a difference in people's lives.",
        "Our philosophy blends old-world charm with a futuristic outlook. We aim to create homes that embody emotions, heritage, and modernity in harmony.",
      ],
    },
  ];

  return (
    <div data-testid="v13-vision-page">
      <PageHeader title="Vision & Philosophy" subtitle="Our Guiding Principles" backgroundImage="/assets/vision/vision.jpeg" />

      <section className="bg-white pt-24 lg:pt-32 pb-24 lg:pb-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-20">
            {blocks.map((b, idx) => (
              <div key={idx} className="flex gap-6 lg:gap-10">
                {/* Vertical rotated label + gold line */}
                <div className="hidden md:flex flex-col items-center">
                  <span
                    className="text-[11px] tracking-[0.3em] uppercase text-[#C4A265]"
                    style={{ writingMode: "vertical-lr", letterSpacing: "0.3em" }}
                  >
                    {b.label}
                  </span>
                  <div className="w-[1px] bg-[#C4A265] flex-1 mt-4 min-h-[120px]" />
                </div>

                {/* Heading + Body */}
                <div className="flex-1">
                  <h2
                    className="text-3xl sm:text-4xl lg:text-5xl text-[#0A0A0A] mb-10 lg:mb-12 leading-[1.05] relative inline-block pr-6"
                    style={{ fontFamily: "'Cormorant Garamond', serif" }}
                  >
                    {b.title}
                    <span className="absolute bottom-2 -right-2 w-2 h-2 rounded-full bg-[#C4A265]" />
                  </h2>
                  {b.paragraphs.map((p, i) => (
                    <p
                      key={i}
                      className="text-[#4A4A4A] leading-relaxed mb-5 last:mb-0"
                      style={{ textAlign: "justify" }}
                    >
                      {p}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};